export default "__VITE_ASSET__c7b2ec99__"